// extracted by mini-css-extract-plugin
export var badge = "_gv-2";
export var detailsPanel = "_gv-0";
export var resultRow = "_gv-1";